<template>
  <BaseModal
    :id="`modalDeleteMessage__${message.messageId}`"
    :size="'md'"
    title="Delete this message"
  >
    <p class="text-dark">Are you sure that you want to delete this message?</p>

    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>
      <b-button variant="danger" @click="handleDelete()">
        <span v-if="!isLoading">Delete</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import { BaseModal } from '@/components/base-components';
import { notificationMixin } from '@/mixins';
import { Channel } from '@/models';

export default {
  name: 'ModalDeleteMessage',

  components: {
    BaseModal
  },

  mixins: [notificationMixin],

  props: {
    channelUrl: {
      type: String,
      default: ''
    },

    message: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    channel() {
      return Channel.findChannel(this.channelUrl);
    }
  },

  methods: {
    show() {
      this.$bvModal.show(`modalDeleteMessage__${this.message.messageId}`);
    },
    hide() {
      this.$bvModal.hide(`modalDeleteMessage__${this.message.messageId}`);
    },
    async handleDelete() {
      this.isLoading = true;

      try {
        await this.channel.deleteMessage(this.message.messageId);

        this.$toast.open({
          message: `Message has been deleted successfully`,
          type: 'success',
          pauseOnHover: true,
          duration: 5000
        });
      } catch (error) {
        this.$toast.open({
          message: error,
          type: 'error',
          pauseOnHover: true,
          duration: 5000
        });
      } finally {
        this.isLoading = false;
      }

      this.$emit('emitDeleteMessage', this.message.messageId);

      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped></style>
